import React from "react";
import { Link } from "react-router-dom";

const RecentActivities = ({ recentActivity, headers }) => {
  return (
    <>
      <p className="page-maintitle">Trending Voucher Sale</p>
      <div class="table-responsive-xl black-header">
        <table
          class="recentact-table mt-3 table ver-middle manage-vou-table dash-list-Table"
          style={{ position: "relative" }}
        >
          <thead className="text-white">
            <tr>
              <th width="300px">Offer Name</th>
              <th width="150px">Marketplace</th>
              <th style={{ textAlign: "end" }}>Amount</th>
              <th className="discount" style={{ textAlign: "end" }}>
                Discount
              </th>
              <th>Vouchers Sold</th>
              <th>Total Redeemed</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            {recentActivity?.length > 0 ? (
              recentActivity.map((item) => {
                return (
                  <tr>
                    <td
                      className="text-left text-limit-2"
                      title={item.offer_name}
                      style={{ textAlign: "left" }}
                    >
                      {item.offer_name}
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <p className="text-limit-2" title={item.market_place}>
                        {item.market_place}
                      </p>
                    </td>
                    <td style={{ textAlign: "end" }}>${item.amount}</td>
                    <td style={{ textAlign: "end" }}>{item.discount}%</td>
                    <td>{item.total_downloaded}</td>
                    <td>{item.total_redeemed}</td>
                    <td>{item.active}</td>
                  </tr>
                );
              })
            ) : (
              <>
                <tr className="noRec-tr">
                  <td colSpan={7} className="noRecords">
                    No records available!!
                  </td>
                </tr>
              </>
            )}
            {recentActivity?.length > 0 ? (
              <tr>
                <td colSpan={7} className="table-viewall">
                  <Link to={"/my-account/vouchers-dashboard"}>View All</Link>
                </td>
              </tr>
            ) : (
              <></>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default RecentActivities;
